export default __webpack_public_path__ + "static/media/ic_payment_a.2b47264a.svg";